var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaved(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "27.8px",
    height: "28px",
    viewBox: "0 0 27.8 28",
    style: {
      enableBackground: "new 0 0 27.8 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.circle{fill:#0FB5F9;}\n\t.star{fill:#FFE000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPads"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 13.9,
    cy: 14,
    r: 13.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "star",
    d: "M18.6,21.5c-0.1,0-0.3,0-0.4-0.1l-4.3-3.2l-4.3,3.2c-0.2,0.2-0.5,0.2-0.8,0c-0.2-0.2-0.3-0.5-0.2-0.8 l1.6-5.2l-4.4-3.3c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.6-0.5h5.4l1.7-5.3c0.2-0.6,1.1-0.6,1.3,0l1.7,5.3h5.4 c0.3,0,0.5,0.2,0.6,0.5c0.1,0.3,0,0.6-0.2,0.8l-4.4,3.3l1.6,5.2c0.1,0.3,0,0.6-0.2,0.8C18.8,21.5,18.7,21.5,18.6,21.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/saved.69688f6a49763c912c23987cb6f03121.svg";
export { ForwardRef as ReactComponent };